// assets\common.js.liquid
function getURLVar(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }	
});

function relocateBoxCartIntoMenu($menu) {
  if (window.innerWidth > 479) return; // остаётся на месте, просто поднимается по z-index через CSS

  var $cart = $('.hd2 .box-cart');
  var $slot = $menu.find('.mobile-menu-cart-slot');
  if (!$cart.length || !$slot.length) return;

  if (!$cart.parent().is($slot)) {
    $cart.addClass('box-cart--in-mobile-menu-bottom').appendTo($slot);
  }
}

function restoreBoxCartFromMenu() {
  var $cart = $('.hd2 .box-cart.box-cart--in-mobile-menu-bottom');
  if (!$cart.length) return;

  $cart.removeClass('box-cart--in-mobile-menu-bottom').insertAfter('.main-menu-custom');
}

$(document).ready(function() {
  if (typeof toastr !== 'undefined') {
    toastr.options.positionClass = 'toast-top-left';
    toastr.options.timeOut = 2200;
    toastr.options.extendedTimeOut = 700;
    toastr.options.hideDuration = 400;
  }

  if ($(".hd3").length) {
    $('body').addClass('hd3');
  }

  // product video 
  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // color swatch js snippet
  $('.swatch :radio').change(function() {
    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
    var optionValue = $(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });

  // product page add to cart
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: $('#form_buy input, #form_buy select'),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

        toastr.success('Congratulation! Item added successfully.')

        $.getJSON('/cart.js', function(cart) {
          $('#cart > button #cart-total').html(cart.item_count);
          $('#cart > button .total-price').html(Shopify.formatMoney(cart.total_price));
          // $('#cart > button').html('<i class="ion-bag"></i><span id="cart-total">' + cart.item_count + '</span>');
          // конвертер валют (snippets/currencies) подключён не на всех страницах
          if (window.Currency && Currency.convertAll) Currency.convertAll(shopCurrency, Currency.cookie.read());
        });

        //$('#cart > .top-cart-contain ul').load('/ #cart > .top-cart-contain ul li');

        reloadHeaderCart();

      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Item variant already added to the cart.')
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  });

  // Sticky header. Spacer lives next to the bar so content does not jump
  // when it goes position:fixed. Stick after the bar has left the viewport;
  // unstick only when the in-flow header is back at the top (not the same
  // threshold — that shoved the page down). Scope to header .fix so blog
  // .fix sidebars are not frozen.
  // Touch devices get CSS position:sticky on #shopify-section-header instead
  // (stylesheet.css.liquid): iOS Safari leaves a gap above a bar that turns
  // fixed while its toolbar collapses. Same media query as the CSS.
  (function initStickyHeader() {
    var $bar = $('header .fix');
    if (!$bar.length) return;

    var $header = $('header').first();
    var $space = $header.children('.headerSpace');
    if (!$space.length) {
      $space = $('<div class="headerSpace" aria-hidden="true"></div>');
      $bar.after($space);
    }

    var touchMq = window.matchMedia ? window.matchMedia('(hover: none) and (pointer: coarse)') : null;

    function teardown() {
      $(window).off('.stickyHeader');
      $bar.removeClass('fix-header');
      $space.removeClass('is-active');
    }

    if (touchMq) {
      var onMqChange = function () { setup(); };
      if (touchMq.addEventListener) touchMq.addEventListener('change', onMqChange);
      else if (touchMq.addListener) touchMq.addListener(onMqChange);
    }

    var originTop = 0;
    var stickAt = 0;

    function setup() {
      teardown();
      if (touchMq && touchMq.matches) return;
      measure();
      $(window).on('scroll.stickyHeader', onScroll);
      $(window).on('resize.stickyHeader load.stickyHeader', function () {
        measure();
        onScroll();
      });
      onScroll();
    }

    function measure() {
      if ($bar.hasClass('fix-header')) {
        $space.css('height', $bar.outerHeight() + 'px');
        return;
      }
      var offset = $header.offset();
      originTop = offset ? offset.top : 0;
      $space.css('height', $bar.outerHeight() + 'px');
      stickAt = originTop + $header.outerHeight() + 30;
    }

    function onScroll() {
      var y = $(window).scrollTop();
      if (!$bar.hasClass('fix-header') && y >= stickAt) {
        $space.addClass('is-active');
        $bar.addClass('fix-header');
      } else if ($bar.hasClass('fix-header') && y <= originTop) {
        $bar.removeClass('fix-header');
        $space.removeClass('is-active');
        measure();
      }
    }

    setup();
  })();

  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');      
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');      
  }

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

// Keep box-cart in sync if viewport crosses 991px while mobile menu is open
$(window).on('resize', function () {
  var $openMenu = $('.mobile-menu.menu-open');
  if (!$openMenu.length) return;

  if (window.innerWidth <= 479) {
    relocateBoxCartIntoMenu($openMenu);
  } else {
    restoreBoxCartFromMenu();
  }
});

  /* Search */
  $('#search input[name=\'q\']').parent().find('button').on('click', function() {
    var url = '/search';
    var value = $('#search input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      jQuery('#search input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=product&q=' + encodeURIComponent(value);
    }
    location = url;
  });

  $('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('header #search input[name=\'q\']').parent().find('button').trigger('click');
    }
  });

  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();

    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

/*
  // Product List
  $('#list-view').click(function() {
    $('#content .product-grid > .clearfix').remove();

    $('#content .row > .product-grid').attr('class', 'product-layout product-list col-xs-12 product-item');
    $('#grid-view').removeClass('active');
    $('#list-view').addClass('active');

    $(".product-item .item").each(function() {
      var action_link = $(this).find('.action-links');
      $(this).find('.price-box').prependTo(action_link);
    });

    localStorage.setItem('display', 'list');
    localStorage.setItem('type', 'none');
  });

  // Product Grid
  $('#grid-view').click(function() {
    var cols = $('#column-right, #column-left').length;

    if (cols == 2) {
      $('#content .product-list').attr('class', 'product-layout product-grid module-style1 col-lg-6 col-md-6 col-sm-6 col-xs-6 product-item');
    } else if (cols == 1) {
      $('#content .product-list').attr('class', 'product-layout product-grid module-style1 col-lg-4 col-md-4 col-sm-6 col-xs-6 product-item');
    } else {
      $('#content .product-list').attr('class', 'product-layout product-grid module-style1 col-lg-3 col-md-3 col-sm-6 col-xs-6 product-item');
    }

    $('#list-view').removeClass('active');
    $('#grid-view').addClass('active');

    $(".product-item .item").each(function() {
      var caption = $(this).find('.caption');
      $(this).find('.price-box').appendTo(caption);
      $(this).find('.box-hover').appendTo(caption);
    });

    localStorage.setItem('display', 'grid');
    localStorage.setItem('type', 'none');
  });

   if (localStorage.getItem('display') == 'list') {
    $('#list-view').trigger('click');
    $('#list-view').addClass('active');
  } else {
    $('#grid-view').trigger('click');
    $('#grid-view').addClass('active');
  }
*/

  // module-style1

  $('.module-style1 .item').mouseover(function() {
    $(this).closest('.module-style1').addClass('active');
  });
  $('.module-style1 .item').mouseout(function() {
    $(this).closest('.module-style1').removeClass('active');
  });

  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function() {
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });

  // Grid/list switcher: default trigger includes focus, so the tip stays after
  // click until the button blurs. Hide as soon as the pointer leaves or clicks.
  $(document).on('mouseleave click', '.modes [data-toggle="tooltip"]', function () {
    var $btn = $(this);
    if ($btn.data('bs.tooltip')) $btn.tooltip('hide');
    if (this.blur) this.blur();
  });

  // Native OS title bubble on links/buttons/images. Strip title while hovered
  // so the browser never schedules it; Bootstrap still uses data-original-title.
  // Nivo keeps title="#caption-id" on hidden slides — restore on leave so captions still work.
  $(document).on('mouseenter', 'a[title], button[title], img[title]', function () {
    var title = this.getAttribute('title');
    if (!title) return;
    this.setAttribute('data-native-title', title);
    this.removeAttribute('title');
  }).on('mouseleave', 'a[data-native-title], button[data-native-title], img[data-native-title]', function () {
    if (!this.getAttribute('title')) {
      this.setAttribute('title', this.getAttribute('data-native-title'));
    }
  });
});


// Обновляет таблицу на /cart через Section Rendering API, если мы сейчас на этой странице
function refreshHeaderCartSkeleton() {
  if (window.ImageSkeleton) ImageSkeleton.init('#cart');
}

// Перерисовывает список в выпадающей корзине хэдера. Берём только секцию
// хэдера (Section Rendering API), а не всю главную: та весит ~1.4 МБ, и пока
// грузилась, в меню висело старое содержимое (счётчик 1, внутри «пусто»).
// Ответ, пришедший позже более свежего запроса, отбрасываем.
var headerCartSeq = 0;
function reloadHeaderCart() {
  var seq = ++headerCartSeq;
  $.get('/?section_id=header', function (html) {
    if (seq !== headerCartSeq) return;
    var $items = $('<div>').append($.parseHTML(html)).find('#cart > ul').children();
    if (!$items.length) return;
    $('#cart > ul').empty().append($items);
    refreshHeaderCartSkeleton();
  });
}

function refreshCartPageSection() {
  if ($('#checkout-cart').length) {
    // Прячем тултипы ДО того как вырвем их триггеры из DOM,
    // иначе всплывающая подсказка (она в <body>, не внутри кнопки) останется висеть
    $('#checkout-cart [data-toggle="tooltip"]').tooltip('hide');

    $.get('/cart?section_id=cart-page', function (html) {
      var $newSection = $('<div>').html(html);
      $('#checkout-cart').replaceWith($newSection.find('#checkout-cart'));
      $('#checkout-cart [data-toggle="tooltip"]').tooltip({container: 'body'});
    });
  }
}
 
var cart = {
  'add': function(product_id, quantity) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        $('.btn-cart > .button').button('loading');
      },
      complete: function() {
        $('.btn-cart > .button').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }

        toastr.success('Congratulation! Your item has been added.')

        $.getJSON('/cart.js', function(cart) {
          setTimeout(function () {
            $('#cart > button #cart-total').html(cart.item_count);
            $('#cart > button .total-price').html(Shopify.formatMoney(cart.total_price));
          }, 25);
        });

        reloadHeaderCart();
        refreshCartPageSection();
      },
      error: function(xhr, ajaxOptions, thrownError) {
        if(xhr.status == 422 ) {
          toastr.warning('Item variant already added to the cart.')
        } else {
          alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
        }
      }
    });
  },
  'remove': function(key, btn) {
    // Блокируем повторный клик по той же кнопке, пока запрос не завершится
    if (btn && $(btn).data('removing')) return;
    if (btn) $(btn).data('removing', true).prop('disabled', true);

    $.ajax({
      url: '/cart/update.js',
      type: 'post',
      data: 'updates['+key+']=0',
      dataType: 'json',
      success: function(json) {
        $('#cart > button #cart-total').html(json['item_count']);
        $('#cart > button .total-price').html(Shopify.formatMoney(json['total_price']));

        if (typeof toastr !== 'undefined') {
          toastr.info('Item removed from cart.');
        }

        var $widgetRow = (btn && $(btn).closest('#cart .dropdown-menu').length) ? $(btn).closest('tr') : null;

        if ($widgetRow && $widgetRow.length) {
          // Клик пришёл из самого виджета - анимированно убираем строку на месте
          $widgetRow.fadeOut(200, function () {
            $(this).remove();
            if (json['item_count'] < 1) {
              $('#cart .dropdown-menu.pull-right').html(
                '<li><p class="text-center cart-empty">Your shopping cart is empty!</p></li>'
              );
            } else {
              // строка убрана на месте, а Subtotal остался старым — подтягиваем
              reloadHeaderCart();
            }
          });
        } else {
          // Клик пришёл из таблицы на /cart (или btn не передан) - просто
          // перезагружаем список виджета целиком, он не участвовал в клике
          reloadHeaderCart();
        }

        refreshCartPageSection();
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      },
      complete: function() {
        if (btn) $(btn).data('removing', false).prop('disabled', false);
      }
    });
  },
  'clear': function() {
    $.ajax({
      url: '/cart/clear.js',
      type: 'post',
      dataType: 'json',
      success: function(json) {
        $('#cart > button #cart-total').html(json['item_count']);
        $('#cart > button .total-price').html(Shopify.formatMoney(json['total_price']));

        if (typeof toastr !== 'undefined') {
          toastr.info('Cart cleared.');
        }

        $('#cart .dropdown-menu.pull-right').html(
          '<li><p class="text-center cart-empty">Your shopping cart is empty!</p></li>'
        );

        refreshCartPageSection();
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  }
}

/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
  e.preventDefault();

  $('#modal-agree').remove();

  var element = this;

  $.ajax({
    url: $(element).attr('href'),
    type: 'get',
    dataType: 'html',
    success: function(data) {
      html  = '<div id="modal-agree" class="modal">';
      html += '  <div class="modal-dialog">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
      html += '      </div>';
      html += '      <div class="modal-body">' + data + '</div>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';

      $('body').append(html);

      $('#modal-agree').modal('show');
    }
  });
});

// Autocomplete */
(function($) {
  $.fn.autocomplete = function(option) {
    return this.each(function() {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);

      $(this).attr('autocomplete', 'off');

      // Focus
      $(this).on('focus', function() {
        this.request();
      });

      // Blur
      $(this).on('blur', function() {
        setTimeout(function(object) {
          object.hide();
        }, 200, this);
      });

      // Keydown
      $(this).on('keydown', function(event) {
        switch(event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });

      // Click
      this.click = function(event) {
        event.preventDefault();

        value = $(event.target).parent().attr('data-value');

        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      }

      // Show
      this.show = function() {
        var pos = $(this).position();

        $(this).siblings('ul.dropdown-menu').css({
          top: pos.top + $(this).outerHeight(),
          left: pos.left
        });

        $(this).siblings('ul.dropdown-menu').show();
      }

      // Hide
      this.hide = function() {
        $(this).siblings('ul.dropdown-menu').hide();
      }

      // Request
      this.request = function() {
        clearTimeout(this.timer);

        this.timer = setTimeout(function(object) {
          object.source($(object).val(), $.proxy(object.response, object));
        }, 200, this);
      }

      // Response
      this.response = function(json) {
        html = '';

        if (json.length) {
          for (i = 0; i < json.length; i++) {
            this.items[json[i]['value']] = json[i];
          }

          for (i = 0; i < json.length; i++) {
            if (!json[i]['category']) {
              html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (i = 0; i < json.length; i++) {
            if (json[i]['category']) {
              if (!category[json[i]['category']]) {
                category[json[i]['category']] = new Array();
                category[json[i]['category']]['name'] = json[i]['category'];
                category[json[i]['category']]['item'] = new Array();
              }

              category[json[i]['category']]['item'].push(json[i]);
            }
          }

          for (i in category) {
            html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

            for (j = 0; j < category[i]['item'].length; j++) {
              html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
            }
          }
        }

        if (html) {
          this.show();
        } else {
          this.hide();
        }

        $(this).siblings('ul.dropdown-menu').html(html);
      }

      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

    });
  }
})(window.jQuery);